import { missingLanguages } from '../lib/i18n/missing'
import type { LayoutDocument, LayoutElement } from './types'

/** The customer languages an element's own words lack (internal/layout/missing.go). */
export function untranslatedIn(el: LayoutElement, languages: readonly string[]): string[] {
  if (el.hidden) return []
  if (el.kind === 'text' || el.kind === 'ticker') return missingLanguages(el.content, languages)
  if (el.kind === 'button') {
    // A title never set under a language shows the service's name there; a blank one is meant.
    const miss = new Set([...missingLanguages(el.content, languages, true), ...missingLanguages(el.subtitle, languages, true)])
    return languages.filter((c) => miss.has(c))
  }
  return []
}

/** Element id → the customer languages its words lack, for every element that lacks one. */
export function untranslatedElements(doc: Pick<LayoutDocument, 'elements' | 'called'>, languages: readonly string[]): Map<string, string[]> {
  const out = new Map<string, string[]>()
  // A stored draft may carry the Called screen's elements packed (calledScreen.ts).
  for (const el of [...doc.elements, ...(doc.called?.elements ?? [])]) {
    const miss = untranslatedIn(el, languages)
    if (miss.length > 0) out.set(el.id, miss)
  }
  return out
}
